import {
  useHeatmapAreaClickContext,
  serializeAreas,
  useHeatmapDataContext,
} from '@gem-sdk/heatmap-react';
import { Box, Button, InlineStack, Text, BlockStack } from '@shopify/polaris';
import { EditIcon } from '@shopify/polaris-icons';
import { useTranslation } from 'react-i18next';
import { SPACING_INSET } from '../Sidebar';
import { useCallback } from 'react';

export const AreaEditModeToggle = () => {
  const isEditingMode = useHeatmapAreaClickContext((s) => s.isEditingMode);
  const setIsEditingMode = useHeatmapAreaClickContext((s) => s.setIsEditingMode);
  const areas = useHeatmapAreaClickContext((s) => s.areas);
  const clearAreas = useHeatmapAreaClickContext((s) => s.clearAreas);
  const setClickAreas = useHeatmapDataContext((s) => s.setClickAreas);

  const { t } = useTranslation();

  const handleClearAll = useCallback(() => {
    clearAreas();
    setClickAreas([]);
  }, [clearAreas, setClickAreas]);

  const handleToggleEditMode = useCallback(() => {
    if (isEditingMode) {
      const persistedAreas = serializeAreas(areas);
      setClickAreas(persistedAreas);
      setIsEditingMode(false);
      return;
    }

    setIsEditingMode(true);
  }, [isEditingMode, setIsEditingMode, areas, setClickAreas]);

  return (
    <Box padding={SPACING_INSET}>
      <BlockStack gap="200">
        <BlockStack gap="200">
          <InlineStack align="space-between" blockAlign="center">
            <Text as="p" variant="bodyMd" fontWeight="medium">
              {t('Click areas')}
            </Text>
            <Button
              icon={EditIcon}
              pressed={isEditingMode}
              onClick={handleToggleEditMode}
              size="slim"
            ></Button>
          </InlineStack>

          {isEditingMode && (
            <Box
              padding="200"
              background="bg-surface-info"
              borderRadius="200"
              borderColor="border-info"
              borderWidth="025"
            >
              <Text as="p" variant="bodySm" tone="subdued">
                {t('Click on elements in the heatmap to create areas')}
              </Text>
            </Box>
          )}
        </BlockStack>

        {areas.length > 0 && (
          <InlineStack align="space-between" blockAlign="center">
            <Text as="p" variant="bodyMd" fontWeight="semibold" tone="subdued">
              {t('{{count}} area(s)', { count: areas.length })}
            </Text>
            <Button variant="plain" tone="critical" size="micro" onClick={handleClearAll}>
              {t('Clear all')}
            </Button>
          </InlineStack>
        )}
      </BlockStack>
    </Box>
  );
};
